/* eslint-disable array-callback-return */

import _ from "lodash";
import moment from "moment";
import { useCallback, useEffect, useMemo, useState } from "react";
import { editTaxInvoiceNumber, mntBillSendEmail, mntBillUpdate, sendTaxInvoiceToNtsAsync } from "src/api/billingSchedule/billingSchedule-api";
import { useApiOperation } from "src/api/hooks";
import { Modal } from "src/api/public-types";
import { BaseButton, BaseInput, BaseModal, BaseTooltip } from "src/components";
import { usePartnerAuthority } from "src/hooks/usePartnerAuthority";
import useContactApi, { objDiff } from "src/pages/contract/hooks/useContractApi";
import { numberToStringWithComma, ViewYmdFormat, YmdFormat } from "src/utils/common-util";
import MakeBillPopup from "../components/MakeBillPopup";
import PaymentStatusView from "../components/PaymentStatusView";
import StorageProcessingModal from "../modal/StorageProcessing/StorageProcessingModal";

// original / changed 비교 위해 타입 정의
type BillDetailItem = {
  adjustAmount: number;
  // baseAmount: number;
  billId: number;
  createdBy: string;
  createdDate: string;
  description: string;
  dtlId: number;
  dtlOrder: number;
  isDeleted: boolean;
  itemName: string;
  modifiedBy: string;
  supplyAmount: number;
  taxAmount: number;
  totalAmount: number;
  trDateTime: string;
};

const MntEditColumns: any = [
  {
    Header: "청구서 명",
    accessor: "bill.billTitle",
    sticky: "left",
    width: 100,
    Cell: ({ value, row, contractBaseInfo, showBtn, selectedScheduleId, buildingId, openToast, callList, getRounds }: any) => {
      //청구서 수정
      const { executeAsync: updateBill } = useApiOperation(mntBillUpdate);
      const [showUpdateBill, setShowUpdateBill] = useState(false);

      const [oriBill, setOriBill] = useState<any>();
      const [bill, setBill] = useState(_.cloneDeep(oriBill));
      const [messageModal, setMessageModal] = useState<Modal>({
        isOpen: false,
      });
      const onClosePopup = useCallback(async () => {
        setShowUpdateBill(false);
        // await getRounds(buildingId, selectedScheduleId);
        await getRounds(buildingId, selectedScheduleId);
        // await callList(selectedScheduleId);
        // setBill(oriBill);
      }, [getRounds, selectedScheduleId, callList, buildingId]);

      // const validateChange = useCallback(
      //   (detailList?: any) => {
      //     let diffKeys: Array<string> = [];
      //     let check = false;
      //     if (detailList) {
      //       const original = _.cloneDeep(oriBill);
      //       const changed = _.cloneDeep(bill);
      //       const oDetail: any = _.cloneDeep(original.billDetailList);
      //       const dl = _.cloneDeep(detailList);
      //       dl.forEach((detail: any) => {
      //         delete detail.checkTaxAmount;
      //         delete detail.isAutoTaxUse;
      //       });
      //       check = JSON.stringify(oDetail) !== JSON.stringify(dl);
      //       // console.log("oDetail", oDetail, "dl", dl);
      //       diffKeys = objDiff(original, changed);
      //       // console.log(
      //       //   "diffKeys",
      //       //   diffKeys.filter(
      //       //     (str: string) =>
      //       //       !str.includes("billDetailList") &&
      //       //       !str.includes("baseAmount") &&
      //       //       !str.includes("totalAmount") &&
      //       //       !str.includes("supplyAmount") &&
      //       //       !str.includes("taxAmount"),
      //       //   ).length > 0,
      //       //   "check",
      //       //   check,
      //       // );
      //       return (
      //         diffKeys.filter(
      //           (str: string) =>
      //             !str.includes("billDetailList") &&
      //             !str.includes("baseAmount") &&
      //             !str.includes("totalAmount") &&
      //             !str.includes("supplyAmount") &&
      //             !str.includes("taxAmount"),
      //         ).length > 0 || check
      //       );
      //     }
      //   },
      //   [bill, oriBill],
      // );

      // v.1.33.2 QA > harry 수정 checkBillChanges 함수로 대응 > 이슈없으면 추후 validateChange 제거예정

      const checkBillChanges = (detailList?: any): boolean => {
        if (!detailList || !oriBill) return false;

        // 비교에서 제외할 필드 목록
        const excludedKeys = [
          "billDetailList",
          "baseAmount",
          "totalAmount",
          "supplyAmount",
          "taxAmount",
          "modifiedDate",
          "modifiedBy",
          "createdDate",
          "createdBy",
        ];

        // bill 객체에서 제외 필드를 제거한 정규화된 객체 생성
        const normalizeBill = (billObj: any) => {
          const normalized: any = {};
          Object.keys(billObj).forEach((key) => {
            if (!excludedKeys.includes(key)) {
              normalized[key] = billObj[key];
            }
          });
          return normalized;
        };

        // 일반 필드 변경 체크 (정규화된 객체로 비교)
        const normalizedOriBill = normalizeBill(oriBill);
        const normalizedBill = normalizeBill(bill);

        const diffKeys = objDiff(normalizedOriBill, normalizedBill);

        if (diffKeys.length > 0) {
          return true;
        }

        const normalizeToBillDetailItem = (item: any): BillDetailItem => ({
          adjustAmount: item.adjustAmount,
          // baseAmount: item.baseAmount,
          billId: item.billId,
          createdBy: item.createdBy,
          createdDate: item.createdDate,
          description: item.description,
          dtlId: item.dtlId,
          dtlOrder: item.dtlOrder,
          isDeleted: item.isDeleted,
          itemName: item.itemName,
          modifiedBy: item.modifiedBy,
          supplyAmount: item.supplyAmount,
          taxAmount: item.taxAmount,
          totalAmount: item.totalAmount,
          trDateTime: item.trDateTime,
        });

        const originalDetails = oriBill.billDetailList?.map(normalizeToBillDetailItem) || [];
        const newDetails = detailList?.map(normalizeToBillDetailItem) || [];

        const isEqual = _.isEqual(originalDetails, newDetails);
        return !isEqual;
      };

      const onConfirmBill = async (detailList?: any) => {
        const temp = _.cloneDeep(bill);
        let sendData: any = { billId: bill.billId };

        sendData.isConfirmed = !temp.isConfirmed;
        // const pass = validateChange(detailList);
        const pass = checkBillChanges(detailList);

        if (pass === undefined || pass === false) {
          const rnt = await updateBill({ scheduleId: selectedScheduleId, body: sendData });
          setBill({ ...temp, ...sendData });
          return rnt;
        } else {
          openToast({ content: "변경 사항이 있습니다. 먼저 저장 후 확정 해주세요 ", isSystemToast: true });
          return;
        }
      };

      /**
       * 저장 버튼 클릭
       */
      const saveBill = useCallback(
        async (detailList: any) => {
          const temp = _.cloneDeep(bill);

          // console.log("update temp", temp);
          let sendData: any = { billId: oriBill.billId };
          const diffKeys = objDiff(oriBill, bill);
          if (diffKeys.length > 0) {
            for (let i = 0; i < diffKeys.length; i++) {
              const key = diffKeys[i];

              if (key !== "billDetailList") {
                sendData[key] = bill[key];
              }
            }
          }
          if (sendData.billStartTime !== "") {
            sendData.billStartTime = moment(temp.billStartTime).format(YmdFormat.WITH_TIME_ZONE);
          }
          if (sendData.billEndTime !== "") {
            sendData.billEndTime = moment(temp.billEndTime).format(YmdFormat.WITH_TIME_ZONE);
          }
          if (sendData.billIssueDate !== "") {
            sendData.billIssueDate = moment(temp.billIssueDate).format(YmdFormat.WITH_TIME_ZONE);
          }
          if (sendData.billDueDate !== "") {
            sendData.billDueDate = moment(temp.billDueDate).format(YmdFormat.WITH_TIME_ZONE);
          }
          if (sendData.taxInvoiceIssueDate !== null) {
            sendData.taxInvoiceIssueDate = moment(temp.taxInvoiceIssueDate).format(YmdFormat.WITH_TIME_ZONE);
          }

          temp.billDetailList = detailList;
          setBill(temp);
          //저장 기능 처리
          sendData.billDetailList = detailList;
          delete sendData.billPayStatus;
          delete sendData.createdDate;
          delete sendData.modifiedDate;
          delete sendData.modifiedBy;
          delete sendData.createdBy;

          return await updateBill({ scheduleId: bill.scheduleId, body: sendData });
        },
        [oriBill, bill, updateBill],
      );
      useEffect(() => {
        setOriBill(_.cloneDeep(row.original.bill));
      }, [row.original]);

      return (
        <div>
          <div
            className="text-underline pointer"
            onClick={(e: any) => {
              e.preventDefault();
              setBill(_.cloneDeep(row.original.bill));
              setShowUpdateBill(true);
            }}
          >
            <div className="w-100 text-left">{value ? <BaseTooltip contents={value} /> : "-"}</div>
          </div>
          {showUpdateBill && (
            <MakeBillPopup
              isChange={showUpdateBill}
              contractDetail={contractBaseInfo}
              showBtn={showBtn}
              bill={_.cloneDeep(bill)}
              setBill={setBill}
              onClose={onClosePopup}
              onConfirm={onConfirmBill}
              onClick={saveBill}
              messageModal={messageModal}
              setMessageModal={setMessageModal}
              getRounds={(scheduleId: string) => getRounds(buildingId, scheduleId)}
              allBill={row.original}
              buildingId={buildingId}
              scheduleId={selectedScheduleId}
            />
          )}
          {messageModal.isOpen && (
            <BaseModal
              isOpen={messageModal.isOpen}
              btnRightTitle={"확인"}
              onClick={async () => {
                setMessageModal({ ...messageModal, isOpen: false });
                await getRounds(bill.buildingId, bill.scheduleId);
              }}
              title={messageModal.message}
            ></BaseModal>
          )}
        </div>
      );
    },
    Footer: ({ rows }: any) => {
      return <p>합계 : </p>;
    },
  },
  {
    Header: "산출기간",
    accessor: "bill.billStartTime",
    sticky: "left",
    width: 120,
    Cell: ({ value, row }: any) => {
      // console.log("row", row.original);
      const start = moment(row.original.bill.billStartTime).format(ViewYmdFormat.YYYY_MM_DD_WEEK);
      const end = moment(row.original.bill.billEndTime).format(ViewYmdFormat.YYYY_MM_DD_WEEK);
      return <p>{start + " ~ " + end}</p>;
    },
  },
  {
    Header: () => {
      return (
        <p>
          청구금액
          <br />
          (원)
        </p>
      );
    },
    accessor: "bill.totalAmount",
    sticky: "left",
    width: 120,
    Cell: ({ value }: any) => {
      return <p>{numberToStringWithComma(value)}</p>;
    },
    Footer: ({ rows }: any) => {
      let sum = 0;
      rows.map((row: any) => {
        sum = sum + Number(row.original.bill.totalAmount);
      });
      return <p>{numberToStringWithComma(sum)}</p>;
    },
  },
  {
    Header: "납부 시작일",
    accessor: "bill.billIssueDate",
    sticky: "left",
    width: 100,
    Cell: ({ value }: any) => {
      return <div>{value ? moment(value).format(ViewYmdFormat.YYYY_MM_DD_WEEK_HH_MM_SS) : "-"} </div>;
    },
  },
  {
    Header: "납부 종료일",
    accessor: "bill.billDueDate",
    sticky: "left",
    width: 100,
    Cell: ({ value, row }: any) => {
      let payLimitDay = row.original.bill.billDueDate;
      return <div>{payLimitDay ? moment(payLimitDay, YmdFormat.WITH_TIME_ZONE).format(ViewYmdFormat.YYYY_MM_DD_WEEK_HH_MM_SS) : "-"} </div>;
    },
  },
  {
    Header: "수납확인",
    accessor: "recieve",
    sticky: "left",
    width: 100,
    Cell: ({ value, row, rows, contractBaseInfo, buildingId, scheduleId, showBtn, getRounds }: any) => {
      // const [prevStatus, setPrevStatus] = useState<any>("");
      const [isChange, setIsChange] = useState(false);
      // console.log("row.", row);
      const pDatas = useMemo(() => {
        return {
          row,
          rows,
          callList: getRounds,
          contractBaseInfo,
          buildingId,
          scheduleId: row.original.bill.scheduleId,
          showBtn,
          isChange,
          setIsChange,
          type: "mnt",
        };
      }, [row, rows, getRounds, contractBaseInfo, buildingId, showBtn, isChange]);

      return (
        <div>
          <div>
            {showBtn && row.original.bill.billPayStatus !== "PAYMENT_SUCCESS" && row.original.bill.billPayStatus !== "TEMP_SAVE" ? (
              <BaseButton
                title={row.original.receiptBundle.receiptList.length > 0 ? "수정" : "수납처리"}
                className="color-white size-small"
                disabled={Number(row.original.bill.totalAmount) > 0 || row.original.bill.billPayStatus === "PAYMENT_READY" ? false : true}
                onClick={() => setIsChange(true)}
              />
            ) : row.original.bill.billPayStatus === "TEMP_SAVE" &&
              row.original.bill.isConfirmed === false &&
              row.original.billEtc.chargeEmailSentAt === "" ? (
              <p>-</p>
            ) : (
              <BaseButton
                title={"수납확인"}
                className="color-white size-small"
                disabled={row.original.billReceipt !== null ? false : row.original.bill.billPayStatus === "PAYMENT_READY" ? false : true}
                onClick={() => setIsChange(true)}
              />
            )}
            {isChange && <StorageProcessingModal processData={pDatas} />}
          </div>
        </div>
      );
    },
  },
  {
    Header: "연체 기간(일)",
    accessor: "receiptBundle.totalOverdueDays",
    // sticky: "left",
    width: 110,
    Cell: ({ value }: any) => {
      return <div>{value ? value + "일" : "-"} </div>;
    },
    Footer: ({ rows }: any) => {
      let sum = 0;

      rows.forEach((row: any) => {
        if (row.original.receiptBundle.totalOverdueDays !== undefined) {
          sum += Number(row.original.receiptBundle.totalOverdueDays);
        }
      });
      return <p>{numberToStringWithComma(sum)}</p>;
    },
  },
  {
    Header: "연체 금액(원)",
    accessor: "receiptBundle.accruedOverdueAmount",
    // sticky: "left",
    width: 110,
    Cell: ({ value, row }: any) => {
      let realtimeOverdueAmount = 0;
      if (row.original.receiptBundle.realtimeOverdueAmount !== undefined) {
        realtimeOverdueAmount += Number(row.original.receiptBundle.realtimeOverdueAmount);
      }

      if (row.original.receiptBundle.accruedOverdueAmount !== undefined) {
        realtimeOverdueAmount += Number(row.original.receiptBundle.accruedOverdueAmount);
      }
      const today = moment();
      const billDate = moment(row.original.bill.billIssueDate);
      if (moment(today).isSameOrAfter(moment(billDate))) {
        return <div>{numberToStringWithComma(Number(realtimeOverdueAmount))} </div>;
      } else {
        return <p>-</p>;
      }
    },
    Footer: ({ rows }: any) => {
      let sum = 0;
      rows.forEach((row: any) => {
        if (row.original.receiptBundle.realtimeOverdueAmount !== undefined) {
          sum += Number(row.original.receiptBundle.realtimeOverdueAmount);
        }

        if (row.original.receiptBundle.accruedOverdueAmount !== undefined) {
          sum += Number(row.original.receiptBundle.accruedOverdueAmount);
        }
      });
      return <p>{numberToStringWithComma(sum)}</p>;
    },
  },

  {
    Header: "거래일시",
    accessor: "receiptBundle.lastTrDateTime",
    width: 100,
    Cell: ({ value, row }: any) => {
      return value ? moment(value).format(ViewYmdFormat.YYYY_MM_DD_WEEK_HH_MM_SS) : "-";
    },
  },
  {
    Header: "수납 전 금액",
    accessor: "receiptBundle.billTotalAmount",
    // sticky: "left",
    width: 110,
    Cell: ({ row, value }: any) => {
      if (moment().isSameOrAfter(moment(row?.original?.bill?.billIssueDate))) {
        return <div>{numberToStringWithComma(Number(value))} </div>;
      } else {
        return <p>-</p>;
      }
    },
    Footer: ({ rows }: any) => {
      let sum = 0;
      rows.map((row: any) => {
        if (moment().isSameOrAfter(moment(row?.original?.bill?.billIssueDate))) {
          sum = sum + Number(row?.original?.receiptBundle?.billTotalAmount);
        }
      });
      return <p>{numberToStringWithComma(sum) + " 원"}</p>;
    },
  },
  {
    Header: "수납금액",
    accessor: "receiptBundle.receiptTotalAmount",
    // sticky: "left",
    width: 110,
    Cell: ({ row, value }: any) => {
      if (moment().isSameOrAfter(moment(row?.original?.bill?.billIssueDate))) {
        return <div>{numberToStringWithComma(Number(value))} </div>;
      } else {
        return <p>-</p>;
      }
    },
    Footer: ({ rows }: any) => {
      let sum = 0;
      rows.map((row: any) => {
        if (moment().isSameOrAfter(moment(row?.original?.bill?.billIssueDate))) {
          sum = sum + Number(row?.original?.receiptBundle?.receiptTotalAmount);
        }
      });
      return <p>{numberToStringWithComma(sum) + " 원"}</p>;
    },
  },
  {
    Header: "잔액",
    accessor: "receiptBundle.billUnpaidAmount",
    // sticky: "left",
    width: 110,
    Cell: ({ row, value }: any) => {
      if (moment().isSameOrAfter(moment(row?.original?.bill?.billIssueDate))) {
        return <div>{value > 0 ? "-" + numberToStringWithComma(Number(value)) : "0"} </div>;
      } else {
        return <p>-</p>;
      }
    },
    Footer: ({ rows }: any) => {
      let sum = 0;
      rows.map((row: any) => {
        if (moment().isSameOrAfter(moment(row?.original?.bill?.billIssueDate))) {
          sum = sum + Number(row?.original?.receiptBundle?.billUnpaidAmount);
        }
      });
      return <p>{sum > 0 ? "-" + numberToStringWithComma(sum) + " 원" : "0 원"}</p>;
    },
  },
  {
    Header: "상태",
    accessor: "bill.billPayStatus",
    // sticky: "right",
    width: 90,
    Cell: ({ value, row }: any) => {
      // 연체 표시 : -
      if (row.original.bill.billPayStatus === "PAYMENT_READY" && moment().isAfter(moment(row?.original?.bill?.billDueDate))) {
        value = "PAYMENT_DELAY";
      }

      return value === "TEMP_SAVE" ? <div className={`chip blue`}>{"임시저장"}</div> : <PaymentStatusView value={value} />;
    },
  },
  {
    Header: "승인",
    accessor: "bill.isConfirmed",
    // sticky: "right",
    width: 90,
    Cell: ({ value, row }: any) => {
      return (
        <div className={`${String(value) === "true" ? "chip green" : "chip red"}`}>
          <p>{String(value) === "true" ? "확정" : "미확정"}</p>
        </div>
      );
    },
  },
  {
    Header: "이메일",
    accessor: "bill.billPayStatus.2",
    // sticky: "right",
    width: 90,
    Cell: ({ value, row, showBtn, messageModal, setMessageModal, getRounds, buildingId, openToast }: any) => {
      const sendHistory = row.original.billEtc.chargeEmailSentAt;
      const { executeAsync: sendEmail } = useApiOperation(mntBillSendEmail);

      const today = moment().toDate();
      const [sendFlag, setSendFlag] = useState(false);
      const [msg, setMsg] = useState("관리비 청구서가 이메일로 납부시작일에 예약 발송됩니다.");
      // const;
      const checkIssueDate = useCallback(() => {
        let flag = false;
        if (moment(today).isBefore(moment(row?.original?.bill?.billIssueDate))) {
          // console.log("관리비 청구서가 이메일로 납부시작일에 예약 발송됩니다.");
          setMsg("관리비 청구서가 이메일로 납부시작일에 예약 발송됩니다.");
          flag = false;
        } else if (moment(today).isSame(moment(row?.original?.bill?.billIssueDate))) {
          // console.log("관리비 청구서가 이메일로 즉시 발송됩니다.");
          setMsg("관리비 청구서가 이메일로 즉시 발송됩니다.");
          flag = true;
        } else {
          // console.log("관리비 청구서가 이메일로 즉시 발송됩니다.");
          setMsg("관리비 청구서가 이메일로 즉시 발송됩니다.");
          flag = true;
        }
        return flag;
      }, [row?.original?.bill?.billIssueDate, today]);

      const handleSendMail = useCallback(async () => {
        const flag = checkIssueDate();
        const sendParams: any = { billId: row?.original?.bill?.billId, isSendNow: flag };
        // if (checkIssueDate() === false) {
        //   openToast({ content: "납부시작일에 이메일이 발송됩니다.", isSystemToast: true });
        // }
        await sendEmail(sendParams);
        setMessageModal({ ...messageModal, message: "발송 요청되었습니다.", isOpen: true });
        setSendFlag(false);
        await getRounds(buildingId, row.original.bill.scheduleId);
      }, [
        checkIssueDate,
        row?.original?.bill?.billId,
        row?.original?.bill?.scheduleId,
        sendEmail,
        setMessageModal,
        messageModal,
        getRounds,
        buildingId,
      ]);

      //  청구상태가 ‘저장'이고, 승인이 ‘확정’일때만 버튼 활성화
      return (
        <div>
          <BaseButton
            title={sendHistory === "" ? "발송" : "재발송"}
            className="color-white"
            disabled={row?.original?.bill?.isConfirmed === false}
            onClick={() => {
              checkIssueDate();
              setSendFlag(true);
            }}
          />
          {sendFlag && (
            <BaseModal
              isOpen={sendFlag}
              btnLeftTitle={"취소"}
              btnRightTitle={"발송"}
              onClose={() => {
                setSendFlag(false);
              }}
              onClick={handleSendMail}
              title={"발송하시겠습니까?"}
            >
              <p>{sendHistory !== "" ? "관리비 청구서가 이메일로 재발송됩니다" : msg}</p>
            </BaseModal>
          )}
        </div>
      );
    },
  },
  {
    Header: "발송일시",
    accessor: "billEtc.chargeEmailSentAt",
    // sticky: "right",
    width: 90,
    Cell: ({ value, row }: any) => {
      return <p>{value !== "" ? moment(value).format(ViewYmdFormat.YYYY_MM_DD_WEEK_HH_MM_SS) : "-"}</p>;
    },
  },
  {
    Header: "계산서 작성일",
    accessor: "bill.taxInvoiceIssueDate",
    // sticky: "right",
    width: 90,
    Cell: ({ value, row }: any) => {
      return <p>{value !== "" ? moment(value).format(ViewYmdFormat.YYYY_MM_DD_WEEK) : "-"}</p>;
    },
  },
  {
    Header: "계산서 발행",
    accessor: "bill.billPayStatus.10",
    // sticky: "right",
    width: 90,
    Cell: ({ row, messageModal, setMessageModal, getRounds, buildingId, contractBaseInfo }: any) => {
      const { getProviderData } = useContactApi();
      const { executeAsync: sendNts } = useApiOperation(sendTaxInvoiceToNtsAsync);
      const today = moment().toDate();
      const [sendFlag, setSendFlag] = useState(false);
      const [sendFlag2, setSendFlag2] = useState(false);
      const [sendFlag3, setSendFlag3] = useState(false);
      const [msg, setMsg] = useState("");

      // 계약자 구분 판별 함수
      const getIsBusinessContractor = () => {
        if (!contractBaseInfo?.contractManage?.mbOrganizationId || contractBaseInfo?.contractManage?.mbOrganizationId === "0") {
          return false; // 해당없음
        }

        const classifications = contractBaseInfo?.contractOrganization?.organization?.classifications;
        if (classifications && classifications.includes("INDIVIDUAL")) {
          return false; // 개인
        }

        return true; // 사업자
      };

      const isBusinessContractor = getIsBusinessContractor();

      // const;
      const checkIssueDate = useCallback(async () => {
        const providerData = await getProviderData(row?.original?.bill?.providerId);
        let type = 1;
        if (
          moment(moment(row?.original?.bill?.taxInvoiceIssueDate).format(ViewYmdFormat.YYYY_MM_DD)).isBefore(
            moment(today).format(ViewYmdFormat.YYYY_MM_DD),
          )
        ) {
          //휴무일시 적용 해야함 오늘 날짜 기준으로 휴무일시체크
          const ym = moment(row?.original?.bill?.taxInvoiceIssueDate).format("YYYY.MM");
          const addMd = moment(ym).add(1, "months").add(10, "days");
          const check = moment(addMd).format(ViewYmdFormat.FULL);

          if (moment(moment(today).format(ViewYmdFormat.YYYY_MM_DD)).isSameOrAfter(moment(check).format(ViewYmdFormat.YYYY_MM_DD))) {
            setMsg(
              "관리비 세금계산서/계산서가 즉시 발행됩니다. 선택한 작성일자로 세금계산서 또는 계산서를 발행하면 가산세가 부과될 수 있으니 참고해 주세요",
            );
          } else {
            setMsg("관리비 세금계산서/계산서가 즉시 발행됩니다.");
          }
        }
        if (
          moment(moment(row?.original?.bill?.taxInvoiceIssueDate).format(ViewYmdFormat.YYYY_MM_DD)).isSame(
            moment(today).format(ViewYmdFormat.YYYY_MM_DD),
          )
        ) {
          setMsg("관리비 세금계산서/계산서가 즉시 발행됩니다.");
        }
        if (moment(row?.original?.bill?.taxInvoiceIssueDate).isAfter(moment(today).format(ViewYmdFormat.YYYY_MM_DD))) {
          type = 3;
          setMsg("관리비 세금계산서/계산서가 계산서 작성일에 예약 발행됩니다.");
        }
        return { passYn: providerData.provider.isVerifiedTaxInvoice, type };
      }, [getProviderData, row.original.bill.providerId, row.original.bill.taxInvoiceIssueDate, today]);

      const handleSendNts = useCallback(async () => {
        const sendParams: any = { billId: row.original.bill.billId };

        await sendNts(sendParams);
        setMessageModal({ ...messageModal, message: "발행 요청되었습니다.", isOpen: true });
        setSendFlag(false);
        await getRounds(buildingId, row.original.bill.scheduleId);
      }, [row.original.bill.billId, row.original.bill.scheduleId, sendNts, setMessageModal, messageModal, getRounds, buildingId]);

      //  청구상태가 ‘저장'이고, 승인이 ‘확정’일때만 버튼 활성화
      return (
        <div>
          <BaseButton
            title={"발행"}
            className="color-white"
            disabled={!isBusinessContractor || row.original.bill.billPayStatus === "TEMP_SAVE" || row.original.taxInvoiceList.length > 0}
            onClick={async () => {
              const passYn = await checkIssueDate();
              if (passYn.passYn) {
                passYn.type === 1 ? setSendFlag(true) : setSendFlag3(true);
              } else {
                setSendFlag2(true);
              }
            }}
          />
          {sendFlag && (
            <BaseModal
              isOpen={sendFlag}
              btnLeftTitle={"취소"}
              btnRightTitle={"확인"}
              onClose={() => {
                setSendFlag(false);
              }}
              onClick={handleSendNts}
              title={"발행하시겠습니까?"}
            >
              <p>{msg}</p>
            </BaseModal>
          )}
          {sendFlag2 && (
            <BaseModal
              isOpen={sendFlag2}
              btnRightTitle={"확인"}
              onClick={() => {
                setSendFlag2(false);
              }}
              title={"해당 관리처 정보로 계산서를 발행 할 수 없습니다."}
            >
              <p>{"정산정보 메뉴에서 해당 관리처의 팝빌 인증정보 검증을 실행해 주세요."}</p>
            </BaseModal>
          )}
          {sendFlag3 && (
            <BaseModal
              isOpen={sendFlag3}
              btnRightTitle={"확인"}
              onClick={() => {
                setSendFlag3(false);
              }}
              title={"계산서가 예약 발행됩니다."}
            >
              <p>{"청구서에서 설정한 계산서 작성일자에 예약 발행됩니다."}</p>
            </BaseModal>
          )}
        </div>
      );
    },
  },
  {
    Header: () => {
      return (
        <p>
          세금계산서
          <br />
          승인번호
        </p>
      );
    },
    accessor: "TAX_PLUS",
    // sticky: "right",
    width: 220,
    Cell: ({ value, row, scheduleId, callList, showBtn, getRounds, buildingId }: any) => {
      const [view, setView] = useState(false);
      const [taxInvoice, setTaxInvoice] = useState<any>({ invoiceNumber: "" });
      const [isError, setIsError] = useState(false);
      const [error, setError] = useState("");

      const [original, setOriginal] = useState<any>();

      const { executeAsync: changeTaxInvoice } = useApiOperation(editTaxInvoiceNumber);
      useEffect(() => {
        setTaxInvoice({ invoiceNumber: "" });
        setOriginal({ invoiceNumber: "" });
        if (row.original.taxInvoiceList !== null && Array.isArray(row.original.taxInvoiceList) && row.original.taxInvoiceList.length > 0) {
          const TAX_PLUS_LIST = row.original.taxInvoiceList.filter((invoice: any) => invoice.invoiceType === "TAX_PLUS");
          if (TAX_PLUS_LIST.length > 0) {
            const sorted = _.sortBy(TAX_PLUS_LIST, ["createdDate"], ["DESC"]);

            setTaxInvoice(sorted[0]);
            setOriginal(sorted[0]);
          }
        }
      }, [row.original.taxInvoiceList]);

      const saveTaxInvoice = useCallback(async () => {
        const pattern = /[a-zA-Z0-9]{24}/;
        if (taxInvoice.invoiceNumber === "") {
          setError("국세청 승인번호는 필수 입력 정보입니다.");
          setIsError(true);
          return;
        }

        if (pattern.test(taxInvoice.invoiceNumber) === false) {
          setError("올바르지 않은 국세청 승인번호 형식입니다.");
          setIsError(true);
          return;
        }

        const send = _.cloneDeep(taxInvoice);
        send.billId = row.original.bill.billId;
        send.invoiceType = "TAX_PLUS";

        await changeTaxInvoice({ scheduleId, data: send });

        setView(false);
        setError("국세청 승인번호가 변경되었습니다.");
        setIsError(true);
        await getRounds(buildingId, scheduleId);
      }, [changeTaxInvoice, getRounds, row.original.bill.billId, scheduleId, taxInvoice, buildingId]);

      return (
        <div className="d-flex">
          <div className="flex-center">
            <div className="w-100 text-left mr10">
              {taxInvoice && taxInvoice.invoiceNumber !== undefined && taxInvoice.invoiceNumber !== "" ? (
                <div>
                  <BaseTooltip contents={taxInvoice.invoiceNumber} isSingleLine={true} />
                  {showBtn && (
                    <BaseButton
                      title="수정"
                      disabled={Number(row.original.bill.totalAmount) === 0}
                      className="color-white size-small"
                      onClick={() => setView(true)}
                    />
                  )}
                </div>
              ) : (
                "-"
              )}
            </div>
          </div>

          <BaseModal
            className="dialog-modal small-size"
            isOpen={view}
            btnLeftTitle="취소"
            btnRightTitle="확인"
            onClose={() => {
              setView(false);

              setTaxInvoice(original);
            }}
            onClick={() => saveTaxInvoice()}
          >
            <>
              <div className="modal-title border-bottom">
                <div className="left-area align-items-center">
                  <span>세금계산서 발행 정보 수정</span>
                </div>
                <div className="right-area"></div>
              </div>
              <div className="contents-scroll">
                <table className="inner-table" width="100%">
                  <tbody>
                    <tr>
                      <td colSpan={2} className="text-left font12 text-gray500">
                        <p>* 팝빌에서 자동 발행 된 ‘국세청승인번호’ 가 출력됩니다.</p>
                        <p>* 홈택스를 통해 발행/재발행 시 ‘국세청승인번호(24자리)’ 를 등록 해주세요.</p>
                      </td>
                    </tr>

                    <tr>
                      <td width="180">
                        <div className="flex-center ">
                          <span className="text-gray600">국세청 승인번호</span>
                        </div>
                      </td>
                      <td>
                        <div className="py10">
                          <div className="minmax300 mb8">
                            <BaseInput
                              name={"taxInvoiceNumber"}
                              value={String(taxInvoice?.invoiceNumber)}
                              onChange={(value: string) => {
                                const temp = _.cloneDeep(taxInvoice);
                                temp.invoiceNumber = value;
                                setTaxInvoice(temp);
                              }}
                              maxLength={24}
                              // disabled={true}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          </BaseModal>
          <BaseModal isOpen={isError} btnRightTitle="확인" onClick={() => setIsError(false)}>
            <p>{error}</p>
          </BaseModal>
        </div>
      );
    },
  },
  {
    Header: () => {
      return (
        <p>
          세금계산서
          <br />
          전송일자
        </p>
      );
    },
    accessor: "taxInvoiceIssueDate",
    // sticky: "right",
    width: 150,
    Cell: ({ value, row }: any) => {
      const createdDate = useMemo(() => {
        if (row.original.taxInvoiceList !== null && Array.isArray(row.original.taxInvoiceList) && row.original.taxInvoiceList.length > 0) {
          const TAX_PLUS_LIST = row.original.taxInvoiceList.filter((invoice: any) => invoice.invoiceType === "TAX_PLUS");

          const sorted = _.sortBy(TAX_PLUS_LIST, ["createdDate"], ["DESC"]);
          if (sorted.length > 0) {
            return moment(sorted[0].createdDate).format(ViewYmdFormat.YYYY_MM_DD_WEEK_HH_MM_SS);
          }
        }
        // console.log(showBtn);
      }, [row.original.taxInvoiceList]);
      return <p>{createdDate ? createdDate : "-"}</p>;
    },
  },
  {
    Header: () => {
      return (
        <p>
          계산서
          <br />
          승인번호
        </p>
      );
    },
    accessor: "TAX_NONE",
    // sticky: "right",
    width: 220,
    Cell: ({ value, row, scheduleId, callList, showBtn, getRounds, buildingId }: any) => {
      const [view, setView] = useState(false);
      const [taxInvoice, setTaxInvoice] = useState<any>({ invoiceNumber: "" });
      const [isError, setIsError] = useState(false);
      const [error, setError] = useState("");

      const [original, setOriginal] = useState<any>();

      const { executeAsync: changeTaxInvoice } = useApiOperation(editTaxInvoiceNumber);

      useEffect(() => {
        setTaxInvoice({ invoiceNumber: "" });
        setOriginal({ invoiceNumber: "" });
        if (row.original.taxInvoiceList !== null && Array.isArray(row.original.taxInvoiceList) && row.original.taxInvoiceList.length > 0) {
          const TAX_PLUS_LIST = row.original.taxInvoiceList.filter((invoice: any) => invoice.invoiceType !== "TAX_PLUS");
          // console.log('row.original',row.original)

          if (TAX_PLUS_LIST.length > 0) {
            const sorted = _.sortBy(TAX_PLUS_LIST, ["createdDate"], ["DESC"]);
            setTaxInvoice(sorted[0]);
            setOriginal(sorted[0]);
          }
        }
        // console.log(showBtn);
      }, [row.original.taxInvoiceList]);

      const saveTaxInvoice = useCallback(async () => {
        const pattern = /[a-zA-Z0-9]{24}/;
        if (taxInvoice.invoiceNumber === "") {
          setError("국세청 승인번호는 필수 입력 정보입니다.");
          setIsError(true);
          return;
        }

        if (pattern.test(taxInvoice.invoiceNumber) === false) {
          setError("올바르지 않은 국세청 승인번호 형식입니다.");
          setIsError(true);
          return;
        }

        const send = _.cloneDeep(taxInvoice);
        send.billId = row.original.bill.billId;
        send.invoiceType = "TAX_NONE";

        await changeTaxInvoice({ scheduleId, data: send });

        setView(false);
        setError("국세청 승인번호가 변경되었습니다.");
        setIsError(true);
        await getRounds(buildingId, scheduleId);
      }, [taxInvoice, row.original.bill.billId, changeTaxInvoice, scheduleId, getRounds, buildingId]);

      return (
        <div className="d-flex">
          <div className="flex-center">
            <div className="w-100 text-left mr10">
              {taxInvoice && taxInvoice.invoiceNumber !== undefined && taxInvoice.invoiceNumber !== "" ? (
                <>
                  <BaseTooltip contents={taxInvoice.invoiceNumber} isSingleLine={true} />
                  {showBtn && (
                    <BaseButton
                      title="수정"
                      disabled={Number(row.original.bill.totalAmount) === 0}
                      className="color-white size-small"
                      onClick={() => setView(true)}
                    />
                  )}
                </>
              ) : (
                "-"
              )}
            </div>
          </div>

          <BaseModal
            className="dialog-modal small-size"
            isOpen={view}
            btnLeftTitle="취소"
            btnRightTitle="확인"
            onClose={() => {
              setView(false);

              setTaxInvoice(original);
            }}
            onClick={() => saveTaxInvoice()}
          >
            <>
              <div className="modal-title border-bottom">
                <div className="left-area align-items-center">
                  <span>계산서 발행 정보 수정</span>
                </div>
                <div className="right-area"></div>
              </div>
              <div className="contents-scroll">
                <table className="inner-table" width="100%">
                  <tbody>
                    <tr>
                      <td colSpan={2} className="text-left font12 text-gray500">
                        <p>* 팝빌에서 자동 발행 된 ‘국세청승인번호’ 가 출력됩니다.</p>
                        <p>* 홈택스를 통해 발행/재발행 시 ‘국세청승인번호(24자리)’ 를 등록 해주세요.</p>
                      </td>
                    </tr>

                    <tr>
                      <td width="180">
                        <div className="flex-center ">
                          <span className="text-gray600">국세청 승인번호</span>
                        </div>
                      </td>
                      <td>
                        <div className="py10">
                          <div className="minmax300 mb8">
                            <BaseInput
                              name={"taxInvoiceNumber"}
                              value={String(taxInvoice?.invoiceNumber)}
                              onChange={(value: string) => {
                                const temp = _.cloneDeep(taxInvoice);
                                temp.invoiceNumber = value;
                                setTaxInvoice(temp);
                              }}
                              maxLength={24}
                              // disabled={true}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </>
          </BaseModal>
          <BaseModal isOpen={isError} btnRightTitle="확인" onClick={() => setIsError(false)}>
            <p>{error}</p>
          </BaseModal>
        </div>
      );
    },
  },
  {
    Header: () => {
      return (
        <p>
          계산서
          <br />
          전송일자
        </p>
      );
    },
    accessor: "cashBillIssueDate",
    // sticky: "right",
    width: 150,
    Cell: ({ value, row, showBtn }: any) => {
      const createdDate = useMemo(() => {
        if (row.original.taxInvoiceList !== null && Array.isArray(row.original.taxInvoiceList) && row.original.taxInvoiceList.length > 0) {
          const TAX_PLUS_LIST = row.original.taxInvoiceList.filter((invoice: any) => invoice.invoiceType !== "TAX_PLUS");

          const sorted = _.sortBy(TAX_PLUS_LIST, ["createdDate"], ["DESC"]);
          if (sorted.length > 0) {
            return moment(sorted[0].createdDate).format(ViewYmdFormat.YYYY_MM_DD_WEEK_HH_MM_SS);
          }
        }
        // console.log(showBtn);
      }, [row.original.taxInvoiceList]);
      return <p>{createdDate ? createdDate : "-"}</p>;
    },
  },
];
export const deleteCol = [
  {
    Header: "삭제",
    accessor: "delete",
    sticky: "right",
    width: 90,
    Cell: ({ value, row, selectedScheduleId, messageModal, setMessageModal, getRounds, buildingId }: any) => {
      const { executeAsync: updateBill } = useApiOperation(mntBillUpdate);
      const { isAuthority } = usePartnerAuthority();
      const [delFlag, setDelFlag] = useState(false);
      const billPayStatus = row.original.bill.billPayStatus;
      const handleSendMail = useCallback(async () => {
        await updateBill({ scheduleId: selectedScheduleId, body: { billId: row.original.bill.billId, isDeleted: true } });
        setDelFlag(false);
        setMessageModal({ ...messageModal, isOpen: true, message: "삭제 되었습니다." });
        await getRounds(buildingId, selectedScheduleId);
      }, [messageModal, row, selectedScheduleId, setMessageModal, updateBill, getRounds, buildingId]);

      //청구상태가 ‘저장’이고, ‘승인이 '미확정’일때만 버튼 활성화
      return (
        <div>
          {isAuthority("d", "CONTRACT") && (
            <BaseButton
              title="삭제"
              className="color-white"
              disabled={row.original.bill.isConfirmed || billPayStatus !== "TEMP_SAVE"}
              onClick={() => setDelFlag(true)}
            />
          )}
          {delFlag && (
            <BaseModal
              isOpen={delFlag}
              btnLeftTitle={"취소"}
              btnRightTitle={"삭제"}
              onClose={() => {
                setDelFlag(false);
              }}
              onClick={handleSendMail}
              title={"삭제하시겠습니까?"}
            >
              <p>{"청구서를 삭제하시겠습니까?"}</p>
            </BaseModal>
          )}
        </div>
      );
    },
  },
];
export default MntEditColumns;
